import styled from 'styled-components';
import { AccordionActions as MuiAccordionActions, Accordion, AccordionSummary } from '@mui/material';
import { Grid, colors } from '@custom-components';

export const StyledExpansionPanel = styled(Accordion)`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'inherit')};
`;

export const AccordionHeader = styled(AccordionSummary)`
  background-color: ${colors.colorWhite} !important;
  font-size: ${({ fontSize = 'inherit' }) => fontSize};
  border: 1px solid ${colors.colorGrey04} !important;

  .bookingSearchWidgetCon & {
    min-height: 40px !important;
    margin: 10px 0;
  }
  .propertySearchWidgetCon & {
    min-height: 40px !important;
    margin: 10px 0;
  }
`;

export const AccordionContent = styled(Grid.Container)`
  padding: 24px 16px !important;
  .bookingSearchWidgetCon & {
    padding: 0 !important;
  }
  .propertySearchWidgetCon & {
    padding: 0 !important;
  }
`;

export const AccordionActions = styled(MuiAccordionActions)``;
